import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../../features/auth/authSlice";
import { httpCommonAuth } from "./axios/http.service";
import { ROLES_LIST } from "../../features/roles/roles.config";

let SERVER_URL = "/api";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // development code
  SERVER_URL = "http://localhost:5001/api";
} else {
  // production code
  SERVER_URL = "/api";
}

const baseQuery = fetchBaseQuery({
  baseUrl: SERVER_URL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const { token, roles, selectedTenantId } = getState().auth;
    const isSuperAdmin =
      Array.isArray(roles) && roles.includes(ROLES_LIST.SuperAdmin);

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
      httpCommonAuth.defaults.headers.common[
        "authorization"
      ] = `Bearer ${token}`;
    } else {
      delete httpCommonAuth.defaults.headers.common.authorization;
    }

    if (isSuperAdmin && selectedTenantId) {
      headers.set("X-Tenant-Override", selectedTenantId);
      httpCommonAuth.defaults.headers.common["X-Tenant-Override"] =
        selectedTenantId;
    } else {
      headers.delete("X-Tenant-Override");
      delete httpCommonAuth.defaults.headers.common["X-Tenant-Override"];
    }

    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.originalStatus === 403) {
    // send refresh token to get new access token
    const refreshResult = await baseQuery("/refresh", api, extraOptions);
    console.log(refreshResult);
    if (refreshResult?.data) {
      const { user } = api.getState().auth;
      // store the new token
      api.dispatch(setCredentials({ ...refreshResult.data, user }));
      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  tagTypes: [
    "Tenant",
    "User",
    "Site",
    "BankingAccount",
    "Booking",
    "Notification",
    "Member",
    "Contract",
    "Event",
    "Task",
    "Tournament",
    "Ticket",
    "Survey",
    "News",
    "Training",
    "ShopProduct",
    "ShopOrder",
    "ShopAccess",
    "EDojang",
    "Subscription",
    "TenantBooking",
    "EventRegistration",
  ],
  endpoints: () => ({}),
});
